import {
  PromoteCTAPageData,
  PromoteCTAErrorModalDataJson,
} from './PromoteCTA.model'

export const promoteCTAPageDataJson: PromoteCTAPageData = {
  title: 'Ready for UAT?',
  description:
    "You'll first need to request access to promote your project to a UAT environment.",
  button: {
    promote: 'Promote',
  },
  link: {
    documentationLink: 'Documentation',
    productName: 'Corporate Account Information',
    documentLink: '/api-library/corporate-account-information/ver-2.0/documents/developer-guide'
  },
  modalData: {
    title: 'Please confirm your request',
    description:
      "This request could take a few business days to complete. We'll send you an email with further instructions.",
    buttonLabels: {
      submit: 'Confirm',
      cancel: 'Cancel',
    },
  },
}

export const promoteCTAErrorModalDataJson: PromoteCTAErrorModalDataJson = {
  modalData: {
    title: 'Request is in review',
    description:
      "We've received your request and it's currently in review. We'll send you an email with additional instructions.",
    buttonLabel: {
      close: 'Close',
    },
  },
}
